export enum HeaderDateType {
  Year = 'year',
  Month = 'month',
}
